import { useAsync } from 'core/ui/hooks/useAsync'

import { unassignShipmentDriver } from '../../use-cases/unassignShipmentDriver'

export function useUnassignDriver() {
  const { call, result, status, error } = useAsync(unassignShipmentDriver)

  return { unassignDriver: call, result, requestStatus: status, error }
}
